import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/bendzi/Downloads/unmelektra/src/app/homepage/components/HomepageInteractive.tsx");
